import React from 'react';

export function useOpeningHours({ initialData }) {
    const [data, setData] = React.useState(initialData);

    const editHours = (dayName, period, typeHours, newHour) => {
        setData((data) => {
            const newData = structuredClone(data);
            const day = newData.find((day) => day.day === dayName);
            const hours = day.periods.at(period);
            hours[typeHours] = newHour;
            return newData;
        });
    };

    const addPeriod = (dayName) => {
        setData((data) => {
            const newData = structuredClone(data);
            const day = newData.find((day) => day.day === dayName);
            day.periods.push({ open: '', close: '' });
            return newData;
        });
    };

    const deletePeriod = (dayName, idx) => {
        setData((data) => {
            const newData = structuredClone(data);
            const day = newData.find((day) => day.day === dayName);
            const newPeriods = day.periods.filter((_, pIndex) => pIndex !== idx);
            day.periods = newPeriods;
            return newData;
        });
    };

    const discardChanges = () => {
        setData(initialData);
    };

    return {
        hours: data,
        editHours,
        addPeriod,
        deletePeriod,
        discardChanges
    };
}
